import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Box } from '@mui/material';
import LogoPng from '../assets/icons/logo-512.png';
import constants from '../constants';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  return (
    <RouterLink to={constants.routes.DASHBOARD.path}>
      <Box component="img" src={LogoPng} sx={{ height: 150, ...sx }} />
    </RouterLink>
  );
}
